import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "./ui/sonner";

export const Layout = () => {
    const location = useLocation();
    const isAdmin = location.pathname.startsWith("/admin");

    return (
        <div className="min-h-screen bg-brand-jet text-foreground flex flex-col" data-testid="site-layout">
            {!isAdmin && <Navbar />}
            <main className="flex-1">
                <Outlet />
            </main>
            {!isAdmin && <Footer />}
            <Toaster position="bottom-right" theme="dark" />
        </div>
    );
};

export default Layout;
